import { useState } from 'react';

import PropTypes from 'prop-types';

import { useTargetingVocabulary } from '../../../models/targeting/queries';

import { AudienceCriteriaCard } from './AudienceCriteriaCard';
import { ManagementCriteriaCard } from './ManagementCriteriaCard';

/** The targeting cards of an HR search. */
export const TargetingCriteriaCards = ({ filters, onFilterChange }) => {
	const { data: vocabulary } = useTargetingVocabulary();
	const [open, setOpen] = useState({ audience: false, management: false });
	const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

	if (!vocabulary) return null;

	return (
		<>
			<AudienceCriteriaCard
				filters={filters}
				onFilterChange={onFilterChange}
				vocabulary={vocabulary}
				open={open.audience}
				onToggle={() => toggle('audience')}
			/>
			<ManagementCriteriaCard
				filters={filters}
				onFilterChange={onFilterChange}
				vocabulary={vocabulary}
				open={open.management}
				onToggle={() => toggle('management')}
			/>
		</>
	);
};

TargetingCriteriaCards.propTypes = {
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
};
